import { Skeleton, Typography } from "@mui/material";
import { TaskList } from "src/components/Tasks/TaskList";
import type { UnifiedTask } from "src/services";
import { DashboardEmptyStateText } from "./DashboardEmptyStateText";
import { DASHBOARD_ITEM_PADDING_SX } from "./dashboardItemPadding";

type DashboardTaskRowsProps = {
  tasks: UnifiedTask[];
  emptyText: string;
  listTestId: string;
  scrollTestId: string;
  isLoading: boolean;
  error?: unknown;
  selectedDeviceId?: string;
  fallbackDeviceId?: string;
  preserveTaskOrder?: boolean;
  loadingTestId?: string;
};

const SKELETON_ROW_IDS = [
  "dashboard-task-row-skeleton-1",
  "dashboard-task-row-skeleton-2",
  "dashboard-task-row-skeleton-3",
];

export const DashboardTaskRows = ({
  tasks,
  emptyText,
  listTestId,
  scrollTestId,
  isLoading,
  error,
  selectedDeviceId,
  fallbackDeviceId,
  preserveTaskOrder,
  loadingTestId = "dashboard-task-rows-loading",
}: DashboardTaskRowsProps) => {
  if (isLoading) {
    return (
      <div className="flex flex-col gap-2" data-testid={loadingTestId}>
        {SKELETON_ROW_IDS.map((rowId) => (
          <Skeleton key={rowId} variant="rectangular" height={44} />
        ))}
      </div>
    );
  }

  if (error) {
    return (
      <Typography variant="body2" color="error">
        Failed to load tasks. Please try again.
      </Typography>
    );
  }

  if (tasks.length === 0) {
    return <DashboardEmptyStateText>{emptyText}</DashboardEmptyStateText>;
  }

  return (
    <div
      className="h-full min-h-0 overflow-y-auto"
      data-testid={scrollTestId}
    >
      <TaskList
        tasks={tasks}
        highlightedDeviceId={selectedDeviceId}
        fallbackDeviceId={fallbackDeviceId}
        hasGroupPadding={false}
        showGroupHeadings={false}
        taskRowPadding={DASHBOARD_ITEM_PADDING_SX}
        taskChipDisplay="iconOnly"
        dataTestId={listTestId}
        preserveTaskOrder={preserveTaskOrder}
      />
    </div>
  );
};
